import React from 'react';

import TimeAndTimezone from './TimeAndTimezone';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

interface Props {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
}

export default function DailyForm({ register, errors }: Props) {
  return <TimeAndTimezone errors={errors} register={register} />;
}
